"use client";

import { useState, useTransition } from "react";
import { Button } from "@/components/ui/button";
import { Post } from "@/types/post";
import { MarketingPostGrid } from "@/app/(marketing)/_components/marketing-post-grid";
import { Container } from "@/components/container";

interface MarketingListWithPaginationProps {
  basePath: string;
  initialPosts: Post[];
  totalCount: number;
  loadMoreAction: (offset: number) => Promise<Post[]>;
  emptyMessage: string;
}

export function MarketingListWithPagination({
  basePath,
  initialPosts,
  totalCount,
  loadMoreAction,
  emptyMessage,
}: MarketingListWithPaginationProps) {
  const [posts, setPosts] = useState<Post[]>(initialPosts);
  const [isPending, startTransition] = useTransition();
  const hasMore = posts.length < totalCount;

  const loadMore = () => {
    startTransition(async () => {
      const newPosts = await loadMoreAction(posts.length);
      setPosts((prev) => [...prev, ...newPosts]);
    });
  };

  return (
    <>
      <MarketingPostGrid posts={posts} basePath={basePath} />
      {totalCount === 0 && (
        <Container className="px-6 py-12 text-center lg:px-12">
          <p className="text-muted-foreground mx-auto max-w-lg text-balance">
            {emptyMessage}
          </p>
        </Container>
      )}
      {hasMore && (
        <Container className="p-6 text-center">
          <Button
            onClick={loadMore}
            disabled={isPending}
            variant="outline"
            size="lg"
          >
            {isPending ? "Loading..." : "Load More"}
          </Button>
        </Container>
      )}
    </>
  );
}
